module.exports = __webpack_public_path__ + "static/CrimsonText-Italic-ac7f5928747ca2889b1ddf7b36e0d308.woff";